// src/auth/readinessFetch.ts


import { currentUser } from "./netlifyIdentity";

export async function readinessFetch(path: string, options: RequestInit = {}) {
	const user = currentUser();

	if (!user) {
		throw new Error("Not signed in.");
	}

	const token = await user.jwt(); // refreshes automatically if expired

	return fetch(path, {
		...options,
		headers: {
			...(options.headers || {}),
			Authorization: `Bearer ${token}`,
		},
	});
}
